import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Datenschutz = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      {/* Header with back button */}
      <header className="fixed top-0 left-0 right-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-200">
        <div className="container mx-auto px-6 py-4">
          <Button
            onClick={() => navigate('/')}
            variant="ghost"
            className="text-primary-dark hover:text-accent-green"
          >
            <ArrowLeft className="w-5 h-5 mr-2" />
            Zurück zur Startseite
          </Button>
        </div>
      </header>

      {/* Content */}
      <div className="container mx-auto max-w-4xl px-6 pt-24 pb-20">
        <h1 className="text-4xl font-bold text-primary-dark mb-8">Datenschutzerklärung</h1>

        <div className="space-y-8 text-gray-700 leading-relaxed">
          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">1. Verantwortlicher</h2>
            <p className="mb-4">Verantwortlicher für die Datenverarbeitung im Sinne der DSGVO ist:</p>
            <p className="mb-2">Sofia Laitenberger</p>
            <p className="mb-2">Richard-Linde-Weg 1</p>
            <p className="mb-4">21033 Hamburg, Deutschland</p>
            <p className="mb-2">
              <strong>Telefon:</strong>{' '}
              <a href="tel:015233527031" className="text-accent-green hover:underline">
                +49 (0) 1523 3527031
              </a>
            </p>
            <p>
              <strong>E-Mail:</strong>{' '}
              <a href="mailto:info@brainhurricane.org" className="text-accent-green hover:underline">
                info@brainhurricane.org
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">2. Allgemeines zur Datenverarbeitung</h2>
            <p className="mb-4">
              Datenschutz hat für uns einen hohen Stellenwert. Die Website www.brainhurricane.org kann grundsätzlich
              ohne Angabe personenbezogener Daten besucht werden. Sollten Sie Services in Anspruch nehmen, bei denen
              personenbezogene Daten erforderlich sind, erfolgt eine Verarbeitung nur mit Ihrer Einwilligung oder
              wenn eine gesetzliche Grundlage vorhanden ist. Diese Datenschutzerklärung informiert Sie über Art,
              Umfang und Zweck der Datenverarbeitung sowie über Ihre Rechte.
            </p>
            <p>
              Wir haben angemessene technische und organisatorische Maßnahmen zur Sicherung Ihrer Daten eingeleitet.
              Dennoch können internetgestützte Datenübertragungen Sicherheitslücken aufweisen. Bei Bedenken können Sie
              Daten alternativ (z.B. telefonisch) übermitteln.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">3. Kontaktformular</h2>
            <p className="mb-4">
              <strong>Erhobene Daten:</strong> Wenn Sie das Kontaktformular ausfüllen, werden die eingegebenen Daten
              (Name, E-Mail-Adresse, Nachricht) erhoben.
            </p>
            <p className="mb-4">
              <strong>Zweck der Verarbeitung:</strong> Ihre Anfrage zu bearbeiten und Ihnen zu antworten.
            </p>
            <p className="mb-4">
              <strong>Rechtliche Grundlage:</strong> Art. 6 Abs. 1 a) DSGVO (Einwilligung) oder Art. 6 Abs. 1 f) DSGVO
              (berechtigtes Interesse an Kundenservice).
            </p>
            <p className="mb-4">
              <strong>Speicherdauer:</strong> Kontaktformular-Daten werden nach Bearbeitung Ihrer Anfrage und
              abschließender Kommunikation für 30 Tage gespeichert und dann gelöscht. Nach Ablauf dieser Frist werden
              die Daten dauerhaft entfernt.
            </p>
            <p>
              <strong>Empfänger:</strong> Die Daten werden ausschließlich an den Verantwortlichen (Sofia Laitenberger)
              übermittelt und nicht an Dritte weitergegeben.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">4. Analytik – PostHog</h2>
            <p className="mb-4">
              <strong>Service:</strong> Diese Website nutzt PostHog, ein Web-Analyse-Tool zur Analyse des Besucherverhaltens.
            </p>
            <p className="mb-4">
              <strong>Erhobene Daten:</strong>
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Seitenaufrufe und Navigation</li>
              <li>Verweildauer auf Seiten</li>
              <li>Clicks und Interaktionen</li>
              <li>Browser- und Geräteinformationen</li>
              <li>IP-Adresse (anonymisiert)</li>
              <li>Referrer (vorherige Seite)</li>
              <li>Session Recordings (optionale Bildschirmaufzeichnungen)</li>
            </ul>
            <p className="mb-4">
              <strong>Zweck:</strong> Analyse der Website-Nutzung, um Inhalte und Funktionalität zu verbessern.
            </p>
            <p className="mb-4">
              <strong>Rechtliche Grundlage:</strong> Art. 6 Abs. 1 a) DSGVO (Einwilligung über Consent-Banner).
            </p>
            <p className="mb-4">
              <strong>Speicherdauer:</strong> PostHog speichert Event-Daten standardmäßig für 3 Monate, Person Profiles
              für 1 Jahr. Ältere Daten werden automatisch gelöscht.
            </p>
            <p className="mb-4">
              <strong>Datenschutzerklärung PostHog:</strong>{' '}
              <a
                href="https://posthog.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent-green hover:underline"
              >
                https://posthog.com/privacy
              </a>
            </p>
            <p>
              <strong>Opt-out:</strong> Sie können die Verarbeitung durch PostHog ablehnen, indem Sie im Consent-Banner
              auf der Startseite die Analytik-Cookies ablehnen.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">5. Cookies</h2>
            <p className="mb-4">
              Diese Website verwendet Cookies. Cookies sind kleine Dateien, die auf Ihrem Gerät gespeichert werden.
              Sie ermöglichen es der Website, sich Ihre Präferenzen zu merken.
            </p>
            <p className="mb-4">
              <strong>Cookie-Kategorien:</strong>
            </p>
            <ul className="list-disc pl-6 space-y-3 mb-4">
              <li>
                <strong>Notwendige Cookies:</strong> Für Grundfunktionen der Website erforderlich (z.B.
                Datenschutz-Einstellungen). Diese sind nicht deaktivierbar.
              </li>
              <li>
                <strong>Analytik-Cookies:</strong> Für PostHog-Tracking. Können über das Consent-Banner abgelehnt werden.
              </li>
              <li>
                <strong>Marketing-Cookies:</strong> Derzeit nicht verwendet.
              </li>
              <li>
                <strong>Externe Inhalte:</strong> Für externe Services (z.B. eingebettete Inhalte). Können über das
                Consent-Banner verwaltet werden.
              </li>
            </ul>
            <p>
              <strong>Consent-Management:</strong> Bei Ihrem ersten Besuch erscheint ein Consent-Banner. Ihre
              Einstellungen werden in localStorage gespeichert und können jederzeit geändert werden.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">6. Server-Logfiles</h2>
            <p className="mb-4">
              Der Webhoster speichert automatisch Informationen in sogenannten Server-Logfiles. Dies sind:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>IP-Adresse des zugreifenden Computers</li>
              <li>Datum und Uhrzeit des Zugriffs</li>
              <li>Aufgerufene Seite</li>
              <li>HTTP-Status</li>
              <li>Browser und Betriebssystem</li>
            </ul>
            <p className="mb-4">
              <strong>Zweck:</strong> Sicherheit, technische Fehleranalyse und Missbrauchsprävention.
            </p>
            <p>
              <strong>Speicherdauer:</strong> Server-Logfiles werden standardmäßig nach kurzer Zeit automatisch gelöscht.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">7. Externe Ressourcen</h2>
            <p className="mb-4">
              Diese Website lädt externe Ressourcen, einschließlich Google Fonts für Schrifarten. Beim Laden dieser
              Ressourcen werden Zugriffsdaten (IP-Adresse, Zugriffszeitpunkt) an die jeweiligen Anbieter übermittelt.
            </p>
            <p>
              <strong>Datenschutzerklärung Google Fonts:</strong>{' '}
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noopener noreferrer"
                className="text-accent-green hover:underline"
              >
                https://policies.google.com/privacy
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">8. Ihre Rechte</h2>
            <p className="mb-4">Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>
                <strong>Auskunftspflicht (Art. 15 DSGVO):</strong> Sie können Auskunft über die zu Ihrer Person
                verarbeiteten Daten verlangen.
              </li>
              <li>
                <strong>Berichtigung (Art. 16 DSGVO):</strong> Unrichtige Daten müssen berichtigt werden.
              </li>
              <li>
                <strong>Löschung (Art. 17 DSGVO):</strong> Unter bestimmten Bedingungen können Sie die Löschung Ihrer
                Daten verlangen.
              </li>
              <li>
                <strong>Einschränkung (Art. 18 DSGVO):</strong> Sie können die Verarbeitung einschränken lassen.
              </li>
              <li>
                <strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie haben das Recht, Ihre Daten in einem
                maschinenlesbaren Format zu erhalten.
              </li>
              <li>
                <strong>Widerspruchsrecht (Art. 21 DSGVO):</strong> Sie können der Verarbeitung widersprechen.
              </li>
              <li>
                <strong>Widerruf der Einwilligung:</strong> Sie können erteilte Einwilligungen jederzeit widerrufen.
              </li>
              <li>
                <strong>Beschwerde bei einer Aufsichtsbehörde (Art. 77 DSGVO):</strong> Sie haben das Recht, sich bei
                einer Datenschutzbehörde zu beschweren.
              </li>
            </ul>
            <p>
              Um diese Rechte auszuüben, kontaktieren Sie uns bitte unter:{' '}
              <a href="mailto:info@brainhurricane.org" className="text-accent-green hover:underline">
                info@brainhurricane.org
              </a>
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">9. Links zu externen Websites</h2>
            <p>
              Diese Website enthält möglicherweise Links zu extern gehosteten Websites. Wir haben keinen Einfluss auf
              deren Inhalte und können daher keine Verantwortung für diese übernehmen. Die Betreiber dieser Seiten sind
              selbst für die Einhaltung des Datenschutzes verantwortlich.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-primary-dark mb-4">10. Änderungen dieser Datenschutzerklärung</h2>
            <p>
              Wir können diese Datenschutzerklärung jederzeit anpassen, um sie an veränderte Gegebenheiten anzupassen.
              Die jeweils aktuelle Version wird auf dieser Seite veröffentlicht.
            </p>
          </section>

          <section className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-600 mb-2">
              <strong>Letzte Aktualisierung:</strong> Dezember 2024
            </p>
            <p className="text-sm text-gray-600">
              Diese Datenschutzerklärung ist für einen freiberuflich tätigen Dienstleister gemäß DSGVO und
              deutschem Datenschutzrecht erstellt.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
